import { motion } from "framer-motion";
import { Quote, ArrowUpRight } from "lucide-react";
import SectionLabel from "./SectionLabel";

const items = [
  {
    quote:
      "I've been working with Darshan and team for over 2 years now, and everything is just perfect. I know I don't have to stress about post production weekly.",
    name: "Kushal Lodha",
    role: "Host, Konversation with Kushal",
    link: "https://www.youtube.com/@KushalLodha548",
  },
  {
    quote:
      "The conversations were always good, but the production never reflected that. The edits feel cleaner, the pacing is tighter, and the overall presentation is much more professional.",
    name: "Prakhar Gupta",
    role: "Host, Prakhar Ke Pravachan",
    link: "https://www.youtube.com/@ThePrakharGuptaXperience/videos",
  },
  {
    quote:
      "The short-form clips don't feel like random cuts from the episode. Every clip has a clear hook and stands well on its own. We've started getting far more engagement from repurposed content.",
    name: "Masoom Minawala",
    role: "Host, Masoom Minawala Show",
    link: "https://www.youtube.com/@MasoomMinawala/videos",
  },
  {
    quote:
      "Instead of coordinating with multiple freelancers, I now work with one person who manages the complete production process. The workflow is smoother and the quality is far more consistent.",
    name: "Rahul Jain",
    role: "Host, Wealth Couch by Rahul Jain",
    link: "https://www.youtube.com/playlist?list=PLDB-q26gAMn7xvsF91HVp3Edmcid2X19K",
  },
  {
    quote:
      "The episode trailers have become one of my favourite deliverables. They're concise, engaging and perfect for building anticipation before every release.",
    name: "Sonia Shenoy",
    role: "Host, Money Mindset",
    link: "https://www.youtube.com/@soniashenoyofficial/videos",
  },
  {
    quote:
      "Podcast production used to consume an entire day every week. Now I simply record the conversation and everything else is taken care of. It's saved me countless hours.",
    name: "Sanjay Kathuria",
    role: "Host, Sanjay Kathuria Podcasts",
    link: "https://www.youtube.com/playlist?list=PLadtxDMxtPj7y04TA2yJJfrzM7sXZ_Hh2",
  },
  {
    quote:
      "Every episode is delivered exactly when promised. We receive the edit, trailer, thumbnails, show notes and clips without chasing updates or following up.",
    name: "Team Groww",
    role: "Money Talks by Groww",
    link: "https://www.youtube.com/@MoneytalksbyGroww/videos",
  },
  {
    quote:
      "The biggest improvement wasn't just the editing, it was the packaging. Better titles, better thumbnails and better presentation have made every episode feel more polished.",
    name: "Gunjan",
    role: "Host, Gunjan Shouts",
    link: "https://www.youtube.com/@GunjanShouts/videos",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative px-6 md:px-16 lg:px-32 py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
        <div className="lg:col-span-7">
          <SectionLabel number="07" label="Client Words" testId="testimonials-label" />
          <h2 className="font-display font-bold uppercase text-2xl md:text-4xl tracking-tighter leading-[0.95]">
            Receipts<br />
            <span className="text-[#D4AF37]">from creators.</span>
          </h2>
        </div>
      </div>

      <div className="max-w-7xl mx-auto flex flex-wrap justify-center gap-6">
        {items.map((t, i) => (
          <motion.a
            key={i}
            href={t.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Watch ${t.name} on YouTube`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
            data-testid={`testimonial-${i}`}
            className="group flex relative w-full md:w-[calc(33.333%-1rem)] bg-[#0A0A0A] border border-[#222] border-l-4 border-l-[#F4C75E] p-8 md:p-10 flex-col gap-7 hover:border-[#F4C75E]/60 hover:border-l-[#F4C75E] transition-all duration-500 hover:-translate-y-1"
          >
            <div className="flex items-start justify-between">
              <Quote className="w-9 h-9 text-[#F4C75E]" />
              <span
                aria-hidden
                data-testid={`testimonial-${i}-arrow`}
                className="w-9 h-9 rounded-full border border-[#F4C75E]/30 flex items-center justify-center text-[#F4C75E] opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 -translate-y-1 group-hover:translate-y-0 transition-all duration-500"
              >
                <ArrowUpRight className="w-4 h-4" />
              </span>
            </div>
            <blockquote className="text-base md:text-lg font-medium leading-[1.7] text-[#EAEAEA]">
              &ldquo;{t.quote}&rdquo;
            </blockquote>
            <figcaption className="flex items-center gap-4 pt-5 border-t border-[#222] mt-auto">
              <div
                aria-hidden
                className="w-12 h-12 flex items-center justify-center bg-[#050505] border border-[#F4C75E]/40 text-[#F4C75E] font-display font-bold text-sm tracking-wider group-hover:border-[#F4C75E] transition-colors duration-500"
              >
                {t.name
                  .split(" ")
                  .map((n) => n[0])
                  .slice(0, 2)
                  .join("")}
              </div>
              <div>
                <div className="font-display font-bold text-base group-hover:text-[#F4C75E] transition-colors duration-500">{t.name}</div>
                <div className="text-sm text-[#999] mt-1">
                  {t.role}
                </div>
              </div>
            </figcaption>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
